import { Box } from "@leagueplatform/genesis-core";

type StoreLinkProps = {
  href: string;
  src: string;
  alt: string;
  css?: React.ComponentProps<typeof Box>["css"];
};

export const StoreLink = ({ href, src, alt, css }: StoreLinkProps) => (
  <Box
    as="a"
    href={href}
    target="_blank"
    rel="noreferrer"
    css={{
      display: "block",
    }}
  >
    <Box
      as="img"
      css={{ borderRadius: "8px", height: "60px", maxWidth: "100%", ...css }}
      src={src}
      alt={alt}
    />
  </Box>
);
